var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalyze({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29.92 34.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #65afd3;\n        stroke-miterlimit: 10;\n        stroke-width: .75px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.96,1.95c.56-.94,1.59-1.57,2.76-1.57,1.76,0,3.2,1.42,3.21,3.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.98,3.88c.54-.25,1.14-.39,1.77-.39,2.31,0,4.18,1.87,4.18,4.18,0,.79-.22,1.52-.59,2.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.79,8.75c1.27.81,2.12,2.23,2.12,3.84,0,.74-.17,1.43-.49,2.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.18,13.84c1.99.95,3.37,2.98,3.37,5.34,0,3.27-2.65,5.91-5.91,5.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.59,30.51c.39.11.8.17,1.23.17.23,0,.47-.02.69-.05,2.2-.33,3.89-2.23,3.89-4.53,0-.54-.09-1.06-.27-1.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.96,32.3c.81.89,1.97,1.45,3.26,1.45,1.98,0,3.66-1.31,4.21-3.12"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "14.96 32.3 14.96 24.71 14.96 22.76"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 14.96,
    y1: 11.36,
    x2: 14.96,
    y2: 1.95
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.99,3.56c.01-1.76,1.45-3.19,3.21-3.19,1.17,0,2.2.63,2.76,1.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.95,3.88c-.54-.25-1.14-.39-1.77-.39-2.31,0-4.18,1.87-4.18,4.18,0,.79.22,1.52.59,2.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.5,14.64c-.31-.62-.49-1.31-.49-2.05,0-1.62.84-3.04,2.12-3.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.75,13.84c-1.99.95-3.37,2.98-3.37,5.34,0,3.27,2.65,5.91,5.91,5.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.79,24.55c-.17.48-.27,1-.27,1.55,0,2.29,1.69,4.2,3.89,4.53.23.03.46.05.69.05.43,0,.84-.06,1.23-.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.49,30.63c.55,1.81,2.22,3.12,4.21,3.12,1.29,0,2.46-.56,3.26-1.45"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "14.96 32.3 14.96 24.71 14.96 22.76"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 14.96,
    y1: 11.36,
    x2: 14.96,
    y2: 1.95
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.51,7.85c.74,1.14,2.26,1.46,3.4.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.26,26.51c-1.31.35-2.09,1.7-1.73,3.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.79,18.14c-1.31.35-2.09,1.7-1.73,3.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.22,8.96c0-1.23,1-2.23,2.23-2.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.61,18.82c1.22.17,2.07,1.3,1.9,2.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.95,25.77c1.22.17,2.07,1.3,1.9,2.52"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 14.96,
    cy: 17.06,
    r: 5.7,
    transform: "translate(-5.08 27.7) rotate(-76.72)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.02,15.42c0-1.13-.92-2.05-2.05-2.05s-2.05.92-2.05,2.05c0,.76.41,1.42,1.03,1.78v2.74c0,.57.46,1.03,1.03,1.03s1.03-.46,1.03-1.03v-2.74c.61-.36,1.03-1.02,1.03-1.78Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyze);
export default __webpack_public_path__ + "static/media/analyze.382588477ebb58036f1c52a32b013cbc.svg";
export { ForwardRef as ReactComponent };